export const shouldPopulateStoreFromSearchParams = () => {
  const searchParams = new URLSearchParams(document.location.search);

  return searchParams.has('queryParameters');
};
